
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/produtos/rpa",
      function () {
        return require("private-next-pages/[locale]/produtos/rpa.page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/produtos/rpa"])
      });
    }
  